<template>
  <a-modal :title="this.title" :visible="this.visible" @cancel="cancel" :width="350" @ok="ok">
    <a-form class="baseForm" :form="form" v-bind="formItemLayout" 
      autocomplete="off">
      <a-form-item label="新密码">
        <a-input-password v-decorator="this.pwdValidator" placeholder="请输入新密码" autocomplete="new-password"/>
      </a-form-item>
      <a-form-item label="确认密码">
        <a-input-password v-decorator="this.pwdChkValidator" placeholder="请输入确认密码" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import {RESETUSERPWD,userInfoForm} from "@/../static/js/API/systemManageApis.js";
import _ from "lodash"; // 引入lodash：封装了诸多对字符串，数组，对象等常见数据类型的处理函数
export default {
  props: ["title", "visible", "userId"],
  components: {},
  data() {
    return {
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 16 }
      },
       formItemLayoutWithOutLabel: {
        wrapperCol: { span: 16, offset: 6 }
      },
      validator: userInfoForm,
      pwdValidator:[
        'userPasswd',    //必填输入控件唯一标志
        {
          rules: [{
            required: true,    //是否必填
            message: "请输入登录密码",     //必填验证提示，
            whitespace: true, //必选时，空格是否被视为错误
            validator:(_rule, value)=>{
              if (value === '') {
                return Promise.reject('请输入登录密码');
              } else {
                let confirmPassword = this.form.getFieldValue("confirmPassword");
                if (confirmPassword !== '') {
                  this.form.validateFields('userPasswd');
                }
        
                return Promise.resolve();
              }
            },
            trigger: 'change',
            },
            {
              pattern: /^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9]{6,12}$/,
              message: "密码长度为6-12位,必须由字母、数字组成，区分大小写"
            }
          ]
        }
      ],
      pwdChkValidator:[
        'confirmPassword',    //必填输入控件唯一标志
        {
          rules: [{
            required: true,    //是否必填
           // message: "请输入登录密码",     //必填验证提示，
            whitespace: true, //必选时，空格是否被视为错误
            validator:(_rule, value)=>{
              if (value === '') {
                return Promise.reject('请输入登录密码');
              } else {
                let pwd = this.form.getFieldValue("userPasswd");
                if (value !== pwd) {
                  return Promise.reject('两次输入密码不一致');
                }
        
                return Promise.resolve();
              }
            },
            trigger: 'change',
            },
            {
              pattern: /^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9]{6,12}$/,
              message: "密码长度为6-12位,必须由字母、数字组成，区分大小写"
            }
          ]
        }
      ],
    };
  },
  watch:{
    visible(val){
      if(!val)
        return;
      let self = this;
      self.resetFields();
    }
  },
  methods: {
    resetFields(){
      this.form.resetFields();
    },
    cancel(e) {
      this.form.resetFields();
      this.$emit("cancel", e);
    },
    ok(e) {
      let self = this;
      e.preventDefault();
      self.form.validateFields((err, values) => {
        if(!err){
         values.userId = self.userId;
         RESETUSERPWD(values).then(res =>{
                self.$message.success(res.data);
                if (res.success) {
                  self.resetFields();
                  self.$emit("ok", e); //调用父组件OK方法
                }
         });
        }
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/systemManage/components/pwdAlterModal.vue